(() => {
  const KEY = 'goodElevationSavedLooks';
  const buttons = () => [...document.querySelectorAll('[data-ge-header-saved]')];
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) { return []; }
  };
  const write = (items) => {
    try { localStorage.setItem(KEY, JSON.stringify(items.slice(-30))); } catch (_) {}
  };
  const esc = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const safeUrl = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '#';
    if (raw.startsWith('/') || raw.startsWith('#')) return raw;
    try {
      const url = new URL(raw, window.location.origin);
      if (url.origin === window.location.origin || /^https?:$/.test(url.protocol)) return url.href;
    } catch (_) {}
    return '#';
  };
  const signedIn = () => buttons().some((button) => button.dataset.geSignedIn === 'true');
  const loginUrl = () => buttons().find((button) => button.dataset.geLoginUrl)?.dataset.geLoginUrl || '/account/login';

  const refresh = () => {
    const count = read().length;
    buttons().forEach((button) => {
      const badge = button.querySelector('[data-ge-saved-count]');
      if (badge) {
        badge.textContent = String(Math.min(count, 99));
        badge.hidden = count < 1;
      }
      button.classList.toggle('is-active', count > 0);
      button.title = count ? `${count} saved look${count === 1 ? '' : 's'}` : 'Saved looks';
    });
    const drawer = document.querySelector('[data-ge-saved-drawer]');
    if (drawer && !drawer.hidden) renderDrawer(drawer);
  };

  const showLoginPrompt = () => {
    let modal = document.querySelector('[data-ge-save-login-modal]');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'ge-save-login';
      modal.setAttribute('data-ge-save-login-modal', '');
      modal.innerHTML = `
        <button type="button" class="ge-save-login__backdrop" data-ge-save-login-close aria-label="Close"></button>
        <div class="ge-save-login__dialog" role="dialog" aria-modal="true" aria-labelledby="ge-save-login-title-global">
          <button type="button" class="ge-save-login__close" data-ge-save-login-close aria-label="Close">×</button>
          <h2 id="ge-save-login-title-global">Save your look</h2>
          <p>Sign in to save your looks and access them anytime.</p>
          <a class="ge-save-login__button" data-ge-save-login-link>SIGN IN</a>
        </div>`;
      document.body.appendChild(modal);
      modal.addEventListener('click', (event) => {
        if (event.target.closest('[data-ge-save-login-close]')) modal.hidden = true;
      });
    }
    const link = modal.querySelector('[data-ge-save-login-link]');
    const base = loginUrl();
    const joiner = base.includes('?') ? '&' : '?';
    const returnUrl = `${window.location.pathname}${window.location.search}`;
    link.href = `${base}${joiner}return_url=${encodeURIComponent(returnUrl)}`;
    modal.hidden = false;
  };

  const ensureDrawer = () => {
    let drawer = document.querySelector('[data-ge-saved-drawer]');
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'ge-saved-drawer';
    drawer.hidden = true;
    drawer.setAttribute('data-ge-saved-drawer', '');
    drawer.innerHTML = '<button type="button" class="ge-saved-drawer__backdrop" data-ge-saved-close aria-label="Close saved looks"></button><aside class="ge-saved-drawer__panel" role="dialog" aria-modal="true" aria-label="Saved looks"><div class="ge-saved-drawer__head"><h2>Saved Looks</h2><button type="button" data-ge-saved-close aria-label="Close saved looks">×</button></div><div class="ge-saved-drawer__body" data-ge-saved-body></div></aside>';
    document.body.appendChild(drawer);
    return drawer;
  };

  const renderDrawer = (drawer) => {
    const body = drawer.querySelector('[data-ge-saved-body]');
    const saved = read().slice().reverse();
    if (!saved.length) {
      body.innerHTML = '<div class="ge-saved-empty"><span>♡</span><p>You have no saved looks yet.</p><small>Tap “Save Look” on a recommendation to keep it here.</small></div>';
      return;
    }
    body.innerHTML = saved.map((entry) => {
      const look = entry?.look || {};
      const product = Array.isArray(look.products) ? look.products[0] : (look.product || {});
      const image = product?.image || product?.image_url || look?.image || '';
      const title = product?.title || look?.title || 'Saved complete look';
      const amount = Number(look?.total || product?.price || 0);
      const price = amount ? `R${amount.toLocaleString('en-ZA', {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
      const href = safeUrl(product?.url || product?.product_url || look?.url || '#');
      const content = `${image ? `<img src="${esc(image)}" alt="${esc(title)}" loading="lazy">` : ''}<div class="ge-saved-card__copy"><strong>${esc(title)}</strong>${price ? `<span>${esc(price)}</span>` : ''}</div>`;
      return `<article class="ge-saved-card" data-ge-saved-key="${esc(entry.key || '')}">${href !== '#' ? `<a class="ge-saved-card__link" href="${esc(href)}" aria-label="Open ${esc(title)}">${content}</a>` : `<div class="ge-saved-card__link">${content}</div>`}<button type="button" class="ge-saved-card__remove" data-ge-saved-remove="${esc(entry.key || '')}" aria-label="Remove ${esc(title)} from saved looks">♥</button></article>`;
    }).join('');
  };

  const openDrawer = () => {
    if (!signedIn()) {
      showLoginPrompt();
      return;
    }
    const drawer = ensureDrawer();
    renderDrawer(drawer);
    drawer.hidden = false;
    document.documentElement.classList.add('ge-saved-open');
    buttons().forEach((button) => button.setAttribute('aria-expanded', 'true'));
  };
  const closeDrawer = () => {
    const drawer = document.querySelector('[data-ge-saved-drawer]');
    if (drawer) drawer.hidden = true;
    document.documentElement.classList.remove('ge-saved-open');
    buttons().forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ge-header-saved]')) {
      event.preventDefault();
      openDrawer();
      return;
    }
    const remove = event.target.closest('[data-ge-saved-remove]');
    if (remove) {
      event.preventDefault();
      event.stopPropagation();
      const key = remove.getAttribute('data-ge-saved-remove');
      write(read().filter((entry) => entry.key !== key));
      refresh();
      return;
    }
    if (event.target.closest('[data-ge-saved-close]')) closeDrawer();
    if (event.target.closest('[data-ge-save-look]')) setTimeout(refresh, 0);
  });
  document.addEventListener('goodElevationSavedLooksChanged', refresh);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });
  window.addEventListener('storage', (event) => { if (event.key === KEY) refresh(); });
  document.addEventListener('DOMContentLoaded', refresh);
  refresh();
})();
